<template>
  <div>
    <nav>
      <div class="nav nav-tabs" id="nav-tab" role="tablist">
        <a
          @click="handleStep('LANCAMENTOS_PENDENTE')"
          :class="[
            'nav-link link-nav-resident',
            step == 'LANCAMENTOS_PENDENTE' && 'active',
          ]"
          id="nav-releases-pending"
          data-toggle="tab"
          href="#releases-pending"
          role="tab"
          aria-controls="releases-pending"
          aria-selected="true"
          >FATURAMENTOS PENDENTES</a
        >
        <!-- <a
          @click="handleStep('LANCAMENTOS_EXECUTADO')"
          :class="[
            'nav-link link-nav-resident',
            step == 'LANCAMENTOS_EXECUTADO' && 'active',
          ]"
          id="nav-releases-executed"
          data-toggle="tab"
          href="#releases-executed"
          role="tab"
          aria-controls="releases-executed"
          aria-selected="true"
          >CONTAS A RECEBER (RECEBIDOS)</a
        > -->
      </div>
    </nav>
    <div class="tab-content" id="nav-tabContent">
      <div
        v-if="step == 'LANCAMENTOS_PENDENTE'"
        :class="[
          'tab-pane fade',
          step == 'LANCAMENTOS_PENDENTE' && 'show active',
        ]"
        id="releases-pending"
        role="tabpanel"
        aria-labelledby="nav-releases-pending"
      >
        <releases-pending :resident="resident" />
      </div>
      <div
        v-if="step == 'LANCAMENTOS_EXECUTADO'"
        :class="[
          'tab-pane fade',
          step == 'LANCAMENTOS_EXECUTADO' && 'show active',
        ]"
        id="releases-executed"
        role="tabpanel"
        aria-labelledby="nav-releases-executed"
      >
        <releases-executed :resident="resident" />
      </div>
    </div>
  </div>
</template>

<script>
import ReleasesPending from "./releases/releases-pending.vue";
import ReleasesExecuted from "./releases/releases-executed.vue";

import routes from "../../../routes";

export default {
  name: "MenuReleases",

  components: {
    ReleasesPending,
    ReleasesExecuted,
  },

  props: {
    resident: Object,
  },

  data() {
    return {
      step: "LANCAMENTOS_PENDENTE",
    };
  },

  created() {
    this.retrieve();
  },

  methods: {
    handleStep(step) {
      let newNav;

      if (step == "LANCAMENTOS_PENDENTE") {
        newNav = "releases-pending";
      }

      if (step == "LANCAMENTOS_EXECUTADO") {
        newNav = "releases-executed";
      }

      let { tab, nav } = routes.history.current.query;

      if (nav != newNav) {
        routes.replace({ query: { tab, nav: newNav } });
      }

      this.step = step;
    },
    async retrieve() {
      const { nav } = routes.history.current.query;

      if (nav) {
        if (nav == "releases-pending") {
          this.step = "LANCAMENTOS_PENDENTE";
        }
        if (nav == "releases-executed") {
          this.step = "LANCAMENTOS_EXECUTADO";
        }
      }
    },
  },
};
</script>